<template>
	<div class="comment-item">
		<div class="item-avatar f-fl">
			<div class="bg-d">
				<div class="bg-c" :style="{backgroundImage:'url('+webp(item.userIcon)+')'}"></div>
			</div>
		</div>
		<div class="item-body">
			<main-item :item="item">
			</main-item>
			<div class="reply-block" v-if="showReply">
				<span class="triangle-up"></span>
				<span class="triangle-up-shadow"></span>
				<reply-item 
					v-for="(replyItem, index) of item.replies"
					:open-reply-status="openReplyStatus"
					:open-reply-handle="openReplyHandle"
					:item="replyItem"
					:index="index"
					:count="replyCount"
					:key="replyItem.id">
				</reply-item>
			</div>
		</div>
	</div>
</template>

<script>
import imgMixin from 'mixins/image'
import MainItem from './main-item'
import ReplyItem from './reply-item'
export default {
	mixins: [imgMixin],
	components: {
		MainItem,
		ReplyItem
	},
	props: ['item'],
	data() {
		return {
			openReplyStatus: false
		}
	},
	computed: {
		showReply() {
			if(!Jt.array.isEmpty(this.item.replies)) {
				return true;
			}
			return false;
		},
		replyCount() {
			if(!Jt.array.isEmpty(this.item.replies)) {
				return this.item.replies.length;
			}
			return 0;
		}
	},
	methods: {
		openReplyHandle() {
			this.openReplyStatus = true;
		}
	}
}
</script>


// WEBPACK FOOTER //
// comment-item.vue?b37634a6